import SupplierManagementClient from "./clients/PurchaseOrderClient";

const supplierManagementPath = "supplier-management";

export default {

  getPOItems(id, body) {
    return SupplierManagementClient.post(
      `${supplierManagementPath}/order-items/${id}`, body
    );
  },

  updatePO(data) {
    return SupplierManagementClient.put(
      `${supplierManagementPath}/order-update`,
      data
    );
  },

  updatePOCustomerEntities(data) {
    return SupplierManagementClient.put(
      `${supplierManagementPath}/update-entities`,
      data
    );
  },

  updatePOItem(data) {
    return SupplierManagementClient.put(
      `${supplierManagementPath}/update-po-item`,
      data
    );
  },

  getPOEvents(id, lang = "MX") {
    return SupplierManagementClient.get(
      `${supplierManagementPath}/poEvents/${id}?lang=${lang}`
    );
  },

  getPOComments(id, moduleId, timezone, lang = "MX") {
    return SupplierManagementClient.get(
      `${supplierManagementPath}/purchaseOrderComments/get-comment?rowid=${id}&moduleid=${moduleId}&general=true&zona=${timezone}&lang=${lang}`
    );
  },

  getCatalogs(lang) {
    return SupplierManagementClient.get(`${supplierManagementPath}/catalogs-detail-order${lang ? `?lang=${lang}` : ''}`);
  },

  createComment(data) {
    return SupplierManagementClient.post("purchaseOrderComments/add-comment", data);
  },
  deleteComment(id) {
    return SupplierManagementClient.delete(
      `purchaseOrderComments/delete-comment/${id}`
    );
  },
  filterCatalogs(data) {
    return SupplierManagementClient.post(`${supplierManagementPath}/filterCatalog`, data);
  },
  getGraphic(data) {
    return SupplierManagementClient.post(`${supplierManagementPath}/graphicList`, data);
  },
  getOrders(data) {
    return SupplierManagementClient.post(
      `${supplierManagementPath}/listPurchaseOrders`,
      data
    );
  },


  updatePOItemStatus(data) {
    return SupplierManagementClient.post(
      `${supplierManagementPath}/updatePOItemsStatus`,
      data
    );
  },
  massivePOItemsUpdate(data) {
    return SupplierManagementClient.post(
      `${supplierManagementPath}/massive-update-po-items`,
      data
    );
  },
  parcedPOItems(data) {
    return SupplierManagementClient.post(
      `${supplierManagementPath}/parcedPOItems`,
      data
    );
  },
  getOrdersByShipment(data) {
    return SupplierManagementClient.post(
      `${supplierManagementPath}/getPOByShipments`,
      data
    );
  },
};
